import { render, staticRenderFns } from "./RegistroObservador.vue?vue&type=template&id=8b7e377c&"
import script from "./RegistroObservador.vue?vue&type=script&lang=js&"
export * from "./RegistroObservador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports